<template>
  <div class="custom-timeline">
    <div class="timeline-item" v-for="(item, index) in items" :key="index">
      <div class="timeline-node"></div>
      <div class="timeline-content">
        <div class="timeline-title">{{ item.content }}</div>
        <p class="timeline-time">{{ item.title }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomTimeline',
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    }
  }
}
</script>

<style scoped>
.custom-timeline {
  position: relative;
  padding: 0;
  list-style: none;
}

.timeline-item {
  position: relative;
  padding: 0 0 30px;
  border-left: 2px solid #ececec;
}
.timeline-item:last-child {
  border:none;
}

.timeline-node {
  position: absolute;
  left: -6px;
  top: 0px;
  width: 10px;
  height: 10px;
  background-color: #ececec;
  border-radius: 50%;
  z-index: 1;
}
.timeline-item:last-child .timeline-node {
  left: -4px;
}

.timeline-content {
  margin-left: 4px;
  padding-left: 10px;
  line-height: 100%;
  
}

.timeline-content h3 {
  margin: 0 0 10px;
  font-size: 16px;
}

.timeline-content p {
  margin: 0;
  color: #909399;
}
.timeline-title {
  margin-bottom: 10px;
  color: #333333;
}
.timeline-time {
  font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/base/Timeline.vue